import { useGetAllSitesAndDevicesQuery } from '../../views/AccessControl'
import { useAccessControlStore } from '../../views/AccessControl/AccessControlStore'
import { DataLoader } from './GlobalDataLoader'

/**
 * Define all data loaders needed for the app.
 * Main loaders block app if they fail.
 * Secondary loaders show alerts if they fail but don't block the app.
 */
export const createLoaders = (): DataLoader[] => [
    {
        id: 'accessControl',
        useLoad: useGetAllSitesAndDevicesQuery,
        type: 'secondary',
        onSuccess: (data) => {
            const { setSites, setDevices } = useAccessControlStore.getState()
            setSites(data.sites)
            setDevices(data.devices)
            console.log('Access control data loaded successfully')
        },
        onError: (error) => {
            console.error('Failed to load access control data:', error)
        },
        getUserMessage: () => {
            return 'All features related to access control devices.'
        }
    }
]
